<template>
    <div>
      <p>
        Born 1953<br><br>

        Was elected to the Board of Directors in 2023.
    </p>
    <p>
        Is the owner of Ejendomsselskabet Mariehøj and has primarily worked with investments within international finance and property development as well as investments in a number of start-up companies.
    </p>   

    <p>
        Educated in the financial sector – and holds a state-authorized real estate license.<br>
    </p>

    <p>
        <strong>Director of:</strong><br>
        <ul>
            <li>Ejendomsanpartsselskabet Mariehøj</li>
            
            <li>Bien 2 ApS</li>
        </ul>
    </p>

    <p>
      <strong>Shareholding in the Company</strong><br>

      Preben Hydeskov owns 264,832 shares in Loyal Solutions A/S.
      <br><br>

      Independent in relation to the company and company management: Yes<br>
      Independent in relation to the company's largest shareholders: No<br>
    </p>

    </div>
  </template>
  
  <script>
    export default {
      name: 'PrebenHydeskovDescription',
    }
  </script>